import { h, Fragment } from "preact"
import { useEffect, useState } from "preact/hooks";

const renderQueries = (queries) => (
  <ul className="list-none">
    {queries.map((query) => (
      <li 
        className="mt-6" 
        key={query.styled_text}
      >
        <a 
          href={query.url}
          className="[&>mark]:bg-white [&>mark]:font-medium after:content-none" 
          dangerouslySetInnerHTML={{ __html: query.styled_text }}
          tabIndex="-1"
        />
      </li>
    ))}
  </ul>
)

const TrendingSearches = ({ defaultData }) => {
  const [searchQuery, setSearchQuery] = useState([]);
  const [queries, setQueries] = useState([]);

  const updateTrendingSearches = ({ detail }) => {
    const { results, query } = detail.payload;

    if(!results) {
      setQueries([]);
      return;
    }

    setQueries(results.queries);
    setSearchQuery(query);
  };
    
  useEffect(() => {
    document.addEventListener('search', updateTrendingSearches);

    return () => {
      document.removeEventListener('search', updateTrendingSearches);
    }
  }, []);

  return (
    <>
      <p className="paragraph-3 uppercase !font-medium">{ defaultData.title }</p>

      {searchQuery.length > 1 && queries.length > 0 && renderQueries(queries)}
      {(searchQuery.length < 2 || queries.length === 0) 
        && renderQueries(defaultData.queries)}
    </>
  )
};

export default TrendingSearches;